"use client";
import Loader from "@components/Loader";
import axios from "axios";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap"
import { useSelector } from "react-redux";

export default ({ params }) => {
  const router = useRouter()
  const url = usePathname()
  const [isPageLoading, setisPageLoading] = useState(true)
  const accessToken = useSelector((state) => state.userToken.value.token);
  const [pageContent, setPageContent] = useState()
  useEffect(() => {
    if (params.slug) {
      getContent()
    }
  }, [params])

  const getContent = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.NEXT_PUBLIC_API_URL}editable-pages/${params.slug}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        setPageContent(response.data)
      })
      .catch((error) => {
        router.push("/not-found")

      }).finally(() => setisPageLoading(false));
  };

  return (
    <main className={`d-flex mh-90`}>
      {
        isPageLoading ?
          <Loader />
          :
          <Container>
            <h2 className=" fw-semibold text-primary">
              {pageContent && pageContent.title}
            </h2>
            <Row>
              <Col>
                <div className="mt-4" dangerouslySetInnerHTML={{ __html: pageContent && pageContent.content }} />
              </Col>
            </Row>
          </Container>
      }
    </main>
  )
}